import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import LegalLayout from "./LegalLayout";
import { Check } from "@phosphor-icons/react";

export default function Pricing() {
  const [plans, setPlans] = useState({});
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data || {})).catch(() => {}); }, []);

  return (
    <LegalLayout title="Precios">
      <p>Planes de suscripción de Hephy 3D. Todos incluyen una prueba gratuita y puedes cambiar o cancelar en cualquier momento. Además cobramos una pequeña comisión por venta realizada con el personalizador (por defecto 1.5%).</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 not-prose mt-6" data-testid="pricing-plans">
        {Object.entries(plans).map(([id, p]) => (
          <div key={id} className={`rounded-xl p-5 border ${id === "pro" ? "border-gold/40 bg-[#151208]" : "border-white/10 bg-white/5"}`} data-testid={`pricing-plan-${id}`}>
            <div className="font-serif text-xl capitalize text-white">{p.name || id}</div>
            <div className="mt-2 flex items-end gap-1"><span className="text-3xl font-bold text-white">${p.price}</span><span className="text-neutral-500 text-sm mb-1">/mes</span></div>
            <ul className="mt-4 space-y-1.5 text-sm text-neutral-300">
              {(p.features || []).map((f, i) => (
                <li key={i} className="flex items-start gap-2"><Check size={15} className="text-gold mt-0.5 shrink-0" /> {f}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="mt-8"><Link to="/register" className="text-gold">Crear cuenta →</Link></p>
    </LegalLayout>
  );
}
